<div class="bg-grey-100">
    <div class="inner-page-wrapper py-40 lg:pt-64">
        @if (headline()) {
            @let headlineF = headline() || '' | footnotes;
            <div
                class="font-headline text-24 lg:text-34 mb-24 text-center leading-30 font-medium lg:mb-40 lg:leading-41"
                [innerHTML]="headlineF()"
            ></div>
        }
        <div class="grid grid-cols-2 gap-x-16 gap-y-56 md:grid-cols-3 md:gap-x-32 lg:grid-cols-4 lg:gap-56">
            @for (item of data(); track $index) {
                <div class="lg:pb-24">
                    <ui-m000-c010-image
                        class="mx-auto aspect-square w-full"
                        [alt]="item.imageAlt ?? ''"
                        [image]="{
                            image: item.image,
                            desktop: { width: 262, height: 262 },
                            tablet: { width: 304, height: 304 },
                            mobile: { width: 352, height: 352 },
                        }"
                        classList="w-full"
                        cover
                        priority="false"
                    />
                    <div class="mt-16">
                        @if (item.headline) {
                            @let headline = item.headline | footnotes;
                            <h3 class="text-16 lg:text-24 mb-4 leading-22 lg:leading-30" [innerHTML]="headline()"></h3>
                        }
                        @if (item.copy) {
                            @let copy = item.copy | footnotes;
                            <p class="text-14 lg:text-16 leading-21 lg:leading-27" [innerHTML]="copy()"></p>
                        }
                        @if (item.price) {
                            @let price = item.price | footnotes;

                            <p class="text-14 lg:text-16 font-bold lg:leading-30" [innerHTML]="price()"></p>
                        }
                        @if (item.email) {
                            <a
                                ui-m010-c020-icon-link
                                class="mt-16"
                                [href]="`mailto:${item.email}?subject=${item.emailSubject || ''}`"
                            >
                                {{ item.linkText }}
                            </a>
                        } @else if (item.link) {
                            <a ui-m010-c020-icon-link class="mt-16" [hyundaiRouterLink]="item.link">
                                {{ item.linkText }}
                            </a>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>
